import { Controller } from "stimulus"

// Connects to data-controller="slider"
export default class extends Controller {
  static targets = ["input", "output", "field"]

  updateFromSlider(event) {
    const value = event.target.value
    this.fieldTarget.value = value
    this.outputTarget.textContent = Number(value).toLocaleString()
  }

  updateFromField(event) {
    const value = event.target.value
    this.inputTarget.value = value
    this.outputTarget.textContent = Number(value).toLocaleString()
  }
}
